import React from 'react'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableSortLabel,
  TablePagination,
  Checkbox,
  Button,
} from '@material-ui/core'
import SftpFileRow from './SftpFileRow'

const SftpFilesTable = ({
  files,
  canDownload,
  selected,
  isAllPageSelected,
  onSelectAll,
  onSelectRow,
  sortField,
  sortDirection,
  onSort,
  page,
  rowsPerPage,
  paginationCount,
  onPageChange,
  onRowsPerPageChange,
  onBulkDownload,
  onDownloadFile,
  classes,
}) => {
  const sortableCell = (label, field) => (
    <TableCell className={classes.sortableHeader}>
      <TableSortLabel
        active={sortField === field}
        direction={sortField === field ? sortDirection : 'asc'}
        onClick={() => onSort(field)}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  )

  if (files.length === 0) {
    return (
      <p className={classes.emptyState}>
        No files have been uploaded yet. Please refresh the page to see if any
        new files are available.
      </p>
    )
  }

  return (
    <>
      {canDownload && (
        <div className={classes.actionsBar}>
          <Checkbox
            indeterminate={selected.size > 0 && !isAllPageSelected}
            checked={isAllPageSelected}
            onChange={onSelectAll}
          />
          <Button
            variant="text"
            size="small"
            disabled={selected.size === 0}
            onClick={onBulkDownload}
            style={{ textDecoration: 'underline' }}
          >
            Download
          </Button>
        </div>
      )}
      <Table size="small">
        <TableHead>
          <TableRow>
            {canDownload && <TableCell padding="checkbox" />}
            {sortableCell('FILE NAME', 'fileName')}
            {sortableCell('FORMAT', 'format')}
            {sortableCell('SIZE', 'size')}
            <TableCell>UPLOADED BY</TableCell>
            {sortableCell('DATE', 'lastModified')}
            {canDownload && <TableCell>ACTIONS</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {files.map(file => (
            <SftpFileRow
              key={file.key}
              file={file}
              canDownload={canDownload}
              selected={selected}
              onSelect={onSelectRow}
              onDownloadFile={onDownloadFile}
              classes={classes}
            />
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={paginationCount}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[20, 50, 100]}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </>
  )
}

export default SftpFilesTable
